export default __webpack_public_path__ + "static/25-target-bd53f7c1df8136c52027f1e98f3c5998.png";